(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rp-cart"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rp-cart')) {
  customElements.define('rp-cart',class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const root=this;
      const form=root.querySelector('form');
      if (!form) return;
      let pending=false;
      let quantityTimer;
      root.querySelectorAll('[data-quantity]').forEach(input=>input.addEventListener('change',()=>{
        clearTimeout(quantityTimer);
        quantityTimer=setTimeout(()=>form.requestSubmit(form.querySelector('[name="update"]')),350);
      }));
      form.querySelector('.pw-cart-update-row').hidden=true;
      root.querySelectorAll('[data-quantity-step]').forEach(button=>button.addEventListener('click',()=>{
        if (pending) return;
        const input=button.closest('.pw-cart-quantity').querySelector('input');
        input.value=Math.max(0,(Number(input.value)||0)+Number(button.dataset.quantityStep));
        input.dispatchEvent(new Event('change',{bubbles:true}));
      }));
      form.addEventListener('submit',async event=>{
        event.preventDefault();
        clearTimeout(quantityTimer);
        if (pending || !form.reportValidity()) return;
        const checkout=event.submitter?.name==='checkout';
        const updates={};
        for (const row of root.querySelectorAll('[data-item-key]')) {
          const quantity=Number(row.querySelector('[data-quantity]').value);
          if (!Number.isInteger(quantity)||quantity<0) return;
          updates[row.dataset.itemKey]=quantity;
        }
        pending=true;
        root.querySelector('[data-cart-error]').textContent='';
        root.querySelectorAll('button, [data-quantity]').forEach(button=>button.disabled=true);
        const trigger=event.submitter;
        trigger?.setAttribute('aria-busy','true');
        try {
          const response=await fetch(root.dataset.updateUrl,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({updates})});
          const result=await response.json();
          if (!response.ok) throw new Error(typeof result.description==='string'?result.description:root.dataset.error);
          if (checkout && result.item_count>0) window.location.assign(root.dataset.checkoutUrl);
          else window.location.reload();
        } catch(error) {
          root.querySelector('[data-cart-error]').textContent=root.dataset.error;
          pending=false;
          root.querySelectorAll('button, [data-quantity]').forEach(button=>button.disabled=false);
          trigger?.removeAttribute('aria-busy');
        }
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rp-combo"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rp-combo')) {
  customElements.define('rp-combo', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const root = this;
      const data = JSON.parse(root.querySelector('[data-combo-data]').textContent);
      const params = new URLSearchParams(window.location.search);
      const watch = data.watch.variants.find(variant => String(variant.id) === params.get('watch') && variant.available && variant.price > 0);
      const money = price => new Intl.NumberFormat(root.dataset.locale || 'fr-FR', {style:'currency',currency:root.dataset.currency || 'EUR'}).format(price / 100);
      const one = selector => root.querySelector(selector);
      const buttons = [...root.querySelectorAll('[data-model]')];
      const add = one('[data-add]');
      const buy = one('[data-buy]');
      let selectedModel = null;
      let selectedVariant = null;
      let pending = false;
      let added = false;
      if (!watch) {
        one('[data-invalid]').hidden = false;
        one('[data-model-step]').hidden = true;
        return;
      }
      const back = new URL(data.watch.url,window.location.origin);
      back.searchParams.set('variant',watch.id);
      if (params.has('preview_theme_id')) back.searchParams.set('preview_theme_id',params.get('preview_theme_id'));
      one('[data-back]').href = back.pathname + back.search;
      one('[data-watch-summary]').hidden = false;
      one('[data-watch-image]').src = watch.image;
      one('[data-watch-image]').alt = watch.title;
      one('[data-watch-name]').textContent = watch.title;
      one('[data-watch-price]').textContent = money(watch.price);
      one('[data-total]').textContent = money(watch.price);
      const updateButtons = () => {add.disabled = buy.disabled = pending || added || !selectedVariant;};
      const selectVariant = variant => {
        selectedVariant = variant;
        one('[data-choice-label]').textContent = variant.title.replace(/^Finition \d+\s*—\s*/,'');
        one('[data-strap-preview]').src = variant.image;
        one('[data-strap-preview]').alt = variant.title;
        one('[data-strap-price]').textContent = money(variant.price);
        root.querySelectorAll('[data-finish]').forEach(button => button.setAttribute('aria-pressed',String(button.dataset.finish === String(variant.id))));
        updateButtons();
      };
      const chooseModel = index => {
        selectedModel = data.models[index];
        selectedVariant = null;
        one('[data-status]').textContent = '';
        one('[data-model-step]').hidden = true;
        one('[data-finish-step]').hidden = false;
        one('[data-step-model]').removeAttribute('aria-current');
        one('[data-step-finish]').setAttribute('aria-current','step');
        one('[data-model-name]').textContent = selectedModel.title;
        one('[data-choice-label]').textContent = data.text.selectFinish;
        const preview = selectedModel.variants.find(variant => variant.available);
        one('[data-strap-preview]').src = preview.image;
        one('[data-strap-preview]').alt = selectedModel.title;
        one('[data-strap-price]').textContent = money(preview.price);
        one('[data-finishes]').replaceChildren();
        selectedModel.variants.forEach(variant => {
          const button = document.createElement('button');
          button.type = 'button'; button.dataset.finish = variant.id;
          button.setAttribute('aria-pressed','false');
          button.setAttribute('aria-label',variant.title.replace(/^Finition \d+\s*—\s*/,''));
          button.title = button.getAttribute('aria-label');
          button.disabled = !variant.available;
          const image = document.createElement('img');
          image.src = variant.image; image.alt = ''; image.width = 72; image.height = 72; image.loading = 'lazy';
          button.append(image);
          button.addEventListener('click',() => selectVariant(variant));
          one('[data-finishes]').append(button);
        });
        updateButtons();
        one('[data-finish-heading]').focus();
      };
      buttons.forEach(button => {
        const model = data.models[Number(button.dataset.model)];
        button.disabled = !model?.variants.some(variant => variant.available);
        button.addEventListener('click',() => chooseModel(Number(button.dataset.model)));
      });
      one('[data-change-model]').addEventListener('click',() => {
        if (pending || added) return;
        selectedVariant = null;
        one('[data-model-step]').hidden = false;
        one('[data-finish-step]').hidden = true;
        one('[data-step-finish]').removeAttribute('aria-current');
        one('[data-step-model]').setAttribute('aria-current','step');
        one('[data-model-heading]').focus();
        updateButtons();
      });
      const purchase = async direct => {
        if (pending || added || !selectedVariant) return;
        pending = true; updateButtons();
        const trigger = direct ? buy : add;
        trigger.setAttribute('aria-busy','true');
        one('[data-status]').textContent = data.text.adding;
        const comboId = window.crypto?.randomUUID?.() || String(Date.now()) + '-' + Math.random().toString(36).slice(2);
        const properties = {_popwatch_combo:comboId};
        try {
          const response = await fetch(root.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:watch.id,quantity:1,properties},{id:selectedVariant.id,quantity:1,properties}]})});
          const result = await response.json();
          if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : data.text.error);
          added = true;
          const cartResponse = await fetch(root.dataset.cartJson,{headers:{Accept:'application/json'},cache:'no-store'});
          if (!cartResponse.ok) throw new Error(data.text.discountError);
          const cart = await cartResponse.json();
          const gift = cart.items.find(item => String(item.variant_id) === String(selectedVariant.id) && item.properties?._popwatch_combo === comboId);
          if (!gift || gift.final_line_price !== 0) throw new Error(data.text.discountError);
          window.location.assign(direct ? root.dataset.checkoutUrl : root.dataset.cartUrl);
        } catch (error) {
          one('[data-status]').textContent = added ? data.text.discountError : data.text.error;
          one('[data-recover]').hidden = !added;
          pending = false; trigger.removeAttribute('aria-busy'); updateButtons();
        }
      };
      add.addEventListener('click',() => purchase(false));
      buy.addEventListener('click',() => purchase(true));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rp-editorial"] && !Shopify.designMode) return;
  try {
    
function rpInitVideos() {
  document.querySelectorAll('.rp-video-shield').forEach(shield=>{
    if(shield.dataset.bound) return;
    shield.dataset.bound='true';
    shield.addEventListener('click',event=>{event.preventDefault();event.stopPropagation()});
    shield.addEventListener('dblclick',event=>{event.preventDefault();event.stopPropagation()});
    shield.addEventListener('contextmenu',event=>event.preventDefault());
  });
  document.querySelectorAll('.rp-block video').forEach(video => {
    if (video.dataset.rpBound) return;
    video.dataset.rpBound = 'true';
    video.autoplay = true;
    video.loop = true;
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.controls = false;
    video.disablePictureInPicture = true;
    video.disableRemotePlayback = true;
    ['autoplay','muted','loop','playsinline','webkit-playsinline','disablepictureinpicture','disableremoteplayback'].forEach(name => video.setAttribute(name,''));
    video.removeAttribute('controls');
    video.setAttribute('tabindex','-1');
    let visible = false;
    let retry;
    const play = () => {
      if (!video.isConnected || document.hidden || !visible || !video.paused || video.webkitDisplayingFullscreen) return;
      video.muted = true;
      const attempt = video.play();
      if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
    };
    const observer = new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
      if (visible) play();
    },{threshold:0.01});
    observer.observe(video);
    ['loadeddata','canplay','ended'].forEach(name => video.addEventListener(name,play));
    video.addEventListener('pause',() => {
      clearTimeout(retry);
      retry = setTimeout(play,150);
    });
    document.addEventListener('visibilitychange',play);
    window.addEventListener('pageshow',play);
    ['touchend','pointerup'].forEach(name => document.addEventListener(name,play,{passive:true}));
    
  });
}
rpInitVideos();
document.addEventListener('shopify:section:load',rpInitVideos);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rp-header"]) return;
  try {
    
function rpHeaderInit() {
  const header = document.querySelector('.rp-header');
  if (!header || header.dataset.bound) return;
  header.dataset.bound = 'true';
  const update = () => header.classList.toggle('rp-is-scrolled', window.scrollY > 40);
  update();
  window.addEventListener('scroll', update, { passive: true });
}
rpHeaderInit();
document.addEventListener('shopify:section:load', rpHeaderInit);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rp-metal-limited"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rp-metal-product')) {
  customElements.define('rp-metal-product', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const root = this;
      const form = root.querySelector('form');
      const variantSelect = root.querySelector('[data-variant]');
      const galleries = [...root.querySelectorAll('[data-gallery-color]')];
      const choices = [...root.querySelectorAll('[data-choice]')];
      const activeGallery = () => galleries.find(group => !group.hidden);
      const showSlide = (group, index) => {
        const slides = [...group.querySelectorAll('[data-slide]')];
        if (!slides.length) return;
        const selected = ((index % slides.length) + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== selected; });
        group.querySelectorAll('[data-thumb]').forEach((button, i) => button.setAttribute('aria-pressed', String(i === selected)));
        group.querySelector('[data-image-count]').textContent = (selected + 1) + ' / ' + slides.length;
      };
      galleries.forEach(group => {
        group.querySelectorAll('[data-thumb]').forEach(button => button.addEventListener('click', () => showSlide(group, Number(button.dataset.thumb) - 1)));
        group.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => {
          const slides = [...group.querySelectorAll('[data-slide]')];
          const index = slides.findIndex(slide => !slide.hidden);
          showSlide(group, index + Number(button.dataset.step));
        }));
      });
      const money = cents => new Intl.NumberFormat(root.dataset.locale || 'fr-FR', { style:'currency', currency:root.dataset.currency || 'EUR' }).format(cents / 100);
      const submit = root.querySelector('[data-submit]');
      const buyNow = root.querySelector('[data-buy-now]');
      let purchasePending = false;
      const combo = root.querySelector('[data-combo]');
      const bracelet = root.querySelector('[data-bracelet]');
      const selectedOption = select => select?.selectedOptions[0];
      const selection = () => {
        const watch = selectedOption(variantSelect);
        const strap = selectedOption(bracelet);
        const combined = Boolean(combo?.checked);
        const validWatch = watch?.dataset.available === 'true' && Number(watch.dataset.price) > 0;
        const validStrap = !combined || (strap?.dataset.available === 'true' && Number(strap.dataset.price) > 0);
        return { watch, strap, combined, enabled:root.dataset.checkoutEnabled === 'true', valid:Boolean(validWatch && validStrap) };
      };
      const updatePurchase = () => {
        if (!submit) return;
        const s = selection();
        const cents = Number(s.watch?.dataset.price || 0) + (s.combined ? Number(s.strap?.dataset.price || 0) : 0);
        root.querySelector('[data-price]').textContent = cents > 0 ? money(cents) : '';
        submit.disabled = purchasePending || !s.enabled || !s.valid;
        if (buyNow) buyNow.disabled = submit.disabled;
        submit.firstChild.textContent = !s.enabled ? submit.dataset.pendingLabel : s.valid ? submit.dataset.addLabel : submit.dataset.unavailableLabel;
        if (bracelet) bracelet.disabled = !s.combined;
      };
      const activateColor = () => {
        const option = selectedOption(variantSelect);
        const color = option?.dataset.color;
        const matching = galleries.find(group => group.dataset.galleryColor === color || group.dataset.legacyColor === color);
        galleries.forEach(group => { group.hidden = group !== matching; });
        choices.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.choice === variantSelect?.value)));
        if (!matching) return;
        showSlide(matching, 0);
        root.querySelector('[data-current-color]').textContent = matching.dataset.galleryColor;
        root.querySelector('[data-spec-color]').textContent = matching.dataset.colorLabel || color;
        const detail = root.querySelector('[data-detail-image]');
        detail.src = matching.dataset.detail;
        detail.alt = color;
        ['one','two','three'].forEach(key => {
          const image = root.querySelector('[data-story-image="' + key + '"]');
          const dataKey = 'story' + key[0].toUpperCase() + key.slice(1);
          if (!image) return;
          image.src = matching.dataset[dataKey];
          image.alt = color + " — " + image.closest("article").querySelector("h2").textContent;
        });
        updatePurchase();
      };
      choices.forEach(button => button.addEventListener('click', () => {
        variantSelect.value = button.dataset.choice;
        activateColor();
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variantSelect.value);
        window.history.replaceState({}, '', url);
      }));
      variantSelect?.addEventListener('change', activateColor);
      root.querySelectorAll('[data-color-scroll]').forEach(button => button.addEventListener('click', () => {
        root.querySelector('[data-color-strip]').scrollBy({left:Number(button.dataset.colorScroll) * 174,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }));
      const tabs = [...root.querySelectorAll('[data-tab]')];
      const selectTab = button => {
        tabs.forEach(tab => { const active = tab === button; tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1; });
        root.querySelectorAll('[data-panel]').forEach(panel => { panel.hidden = panel.dataset.panel !== button.dataset.tab; });
      };
      tabs.forEach((button, index) => {
        button.addEventListener('click', () => selectTab(button));
        button.addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          let target = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          selectTab(tabs[target]); tabs[target].focus();
        });
      });
      combo?.addEventListener('change', updatePurchase);
      bracelet?.addEventListener('change', updatePurchase);
      form?.addEventListener('submit', async event => {
        event.preventDefault();
        const s = selection();
        if (purchasePending || !s.enabled || !s.valid) return;
        const directCheckout = event.submitter === buyNow;
        const items = [{id:variantSelect.value,quantity:1}];
        if (s.combined) items.push({id:bracelet.value,quantity:1});
        const status = root.querySelector('[data-status]');
        status.textContent = '';
        purchasePending = true;
        updatePurchase();
        (directCheckout ? buyNow : submit).setAttribute('aria-busy','true');
        try {
          const response = await fetch(root.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
          const data = await response.json();
          if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : status.dataset.error);
          window.location.assign(directCheckout ? root.dataset.checkoutUrl : root.dataset.cartUrl);
        } catch(error) {
          status.textContent = status.dataset.error;
          purchasePending = false;
          submit.removeAttribute('aria-busy'); buyNow?.removeAttribute('aria-busy'); updatePurchase();
        }
      });
      activateColor();
      this.addEventListener('keydown', event => {
        if (!event.target.closest('.rpp-gallery') || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
        const group = activeGallery(); if (!group) return;
        const slides = [...group.querySelectorAll('[data-slide]')];
        showSlide(group,slides.findIndex(slide=>!slide.hidden)+(event.key==='ArrowRight'?1:-1));
        event.preventDefault();
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rp-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rp-watch-product')) {
  customElements.define('rp-watch-product', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const root = this;
      const form = root.querySelector('form');
      const variantSelect = root.querySelector('[data-variant]');
      const galleries = [...root.querySelectorAll('[data-gallery-color]')];
      const choices = [...root.querySelectorAll('[data-choice]')];
      const activeGallery = () => galleries.find(group => !group.hidden);
      const showSlide = (group, index) => {
        const slides = [...group.querySelectorAll('[data-slide]')];
        if (!slides.length) return;
        const selected = ((index % slides.length) + slides.length) % slides.length;
        const stage = group.querySelector('.rpp-gallery-stage');
        if (window.matchMedia('(max-width:749px)').matches && stage) {
          stage.scrollTo({left:selected * stage.clientWidth,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        }
        slides.forEach((slide, i) => { slide.hidden = i !== selected; });
        group.querySelectorAll('[data-thumb]').forEach((button, i) => button.setAttribute('aria-pressed', String(i === selected)));
        group.querySelector('[data-image-count]').textContent = (selected + 1) + ' / ' + slides.length;
      };
      galleries.forEach(group => {
        const range = group.querySelector('.rpp-mobile-scroll');
        range?.addEventListener('input', () => showSlide(group,Number(range.value)));
        const stage = group.querySelector('.rpp-gallery-stage');
        let scrollFrame = 0;
        stage?.addEventListener('scroll', () => {
          if (!window.matchMedia('(max-width:749px)').matches || scrollFrame) return;
          scrollFrame = requestAnimationFrame(() => {
            scrollFrame = 0;
            const slides = [...group.querySelectorAll('[data-slide]')];
            const selected = Math.max(0,Math.min(slides.length - 1,Math.round(stage.scrollLeft / stage.clientWidth)));
            slides.forEach((slide,i) => {slide.hidden = i !== selected;});
            group.querySelectorAll('[data-thumb]').forEach((button,i) => button.setAttribute('aria-pressed',String(i === selected)));
            if (range) range.value = selected;
            const counter = group.querySelector('[data-image-count]');
            if (counter) counter.textContent = (selected + 1) + ' / ' + slides.length;
          });
        },{passive:true});
        group.querySelectorAll('[data-thumb]').forEach(button => button.addEventListener('click', () => showSlide(group, Number(button.dataset.thumb) - 1)));
        group.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => {
          const slides = [...group.querySelectorAll('[data-slide]')];
          const index = slides.findIndex(slide => !slide.hidden);
          showSlide(group, index + Number(button.dataset.step));
        }));
      });
      const money = cents => new Intl.NumberFormat(root.dataset.locale || 'fr-FR', { style:'currency', currency:root.dataset.currency || 'EUR' }).format(cents / 100);
      const submit = root.querySelector('[data-submit]');
      const buyNow = root.querySelector('[data-buy-now]');
      let purchasePending = false;
      const combo = root.querySelector('[data-combo]');
      const bracelet = root.querySelector('[data-bracelet]');
      const selectedOption = select => select?.selectedOptions[0];
      const selection = () => {
        const watch = selectedOption(variantSelect);
        const strap = selectedOption(bracelet);
        const combined = Boolean(combo?.checked);
        const validWatch = watch?.dataset.available === 'true' && Number(watch.dataset.price) > 0;
        const validStrap = !combined || (strap?.dataset.available === 'true' && Number(strap.dataset.price) > 0);
        return { watch, strap, combined, enabled:root.dataset.checkoutEnabled === 'true', valid:Boolean(validWatch && validStrap) };
      };
      const updatePurchase = () => {
        if (!submit) return;
        const s = selection();
        const cents = Number(s.watch?.dataset.price || 0) + (s.combined ? Number(s.strap?.dataset.price || 0) : 0);
        const priceNode=root.querySelector('[data-price]');
        priceNode.replaceChildren();
        const previous=Number(s.watch?.dataset.comparePrice||0);
        if(previous>Number(s.watch?.dataset.price||0)){
          const before=document.createElement('s');before.className='rpp-price-before';
          before.textContent=money(previous+(s.combined?Number(s.strap?.dataset.price||0):0));
          priceNode.append(before);
        }
        const current=document.createElement('span');current.className='rpp-price-current';
        current.textContent=cents>0?money(cents):'';priceNode.append(current);
        submit.disabled = purchasePending || !s.enabled || !s.valid;
        if (buyNow) buyNow.disabled = submit.disabled;
        submit.firstChild.textContent = !s.enabled ? submit.dataset.pendingLabel : s.valid ? submit.dataset.addLabel : submit.dataset.unavailableLabel;
        if (bracelet) bracelet.disabled = !s.combined;
        const gift = root.querySelector('input[name="popwatch_offer"]:checked')?.value === 'gift';
        if (gift && s.enabled && s.valid) submit.firstChild.textContent = root.dataset.comboAddLabel;
        if (buyNow) buyNow.firstChild.textContent = gift ? root.dataset.comboBuyLabel : root.dataset.soloBuyLabel;
      };
      const activateColor = () => {
        const option = selectedOption(variantSelect);
        const color = option?.dataset.color;
        const matching = galleries.find(group => group.dataset.galleryColor === color || group.dataset.legacyColor === color);
        galleries.forEach(group => { group.hidden = group !== matching; });
        choices.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.choice === variantSelect?.value)));
        if (!matching) return;
        showSlide(matching, 0);
        root.querySelector('[data-current-color]').textContent = matching.dataset.galleryColor;
        root.querySelector('[data-model-title]').textContent = matching.dataset.galleryColor;
        root.querySelector('[data-spec-color]').textContent = matching.dataset.colorLabel || color;
        const detail = root.querySelector('[data-detail-image]');
        detail.src = matching.dataset.detail;
        detail.alt = color;
        ['one','two','three'].forEach(key => {
          const image = root.querySelector('[data-story-image="' + key + '"]');
          const dataKey = 'story' + key[0].toUpperCase() + key.slice(1);
          image.src = matching.dataset[dataKey];
          image.alt = color;
        });
        updatePurchase();
      };
      choices.forEach(button => button.addEventListener('click', () => {
        variantSelect.value = button.dataset.choice;
        activateColor();
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variantSelect.value);
        window.history.replaceState({}, '', url);
      }));
      variantSelect?.addEventListener('change', activateColor);
      root.querySelectorAll('[data-color-scroll]').forEach(button => button.addEventListener('click', () => {
        root.querySelector('[data-color-strip]').scrollBy({left:Number(button.dataset.colorScroll) * 174,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }));
      const tabs = [...root.querySelectorAll('[data-tab]')];
      const selectTab = button => {
        tabs.forEach(tab => { const active = tab === button; tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1; });
        root.querySelectorAll('[data-panel]').forEach(panel => { panel.hidden = panel.dataset.panel !== button.dataset.tab; });
      };
      tabs.forEach((button, index) => {
        button.addEventListener('click', () => selectTab(button));
        button.addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          let target = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          selectTab(tabs[target]); tabs[target].focus();
        });
      });
      root.querySelectorAll('input[name="popwatch_offer"]').forEach(input => input.addEventListener('change',updatePurchase));
      combo?.addEventListener('change', updatePurchase);
      bracelet?.addEventListener('change', updatePurchase);
      form?.addEventListener('submit', async event => {
        event.preventDefault();
        const s = selection();
        if (purchasePending || !s.enabled || !s.valid) return;
        const directCheckout = event.submitter === buyNow;
        if (root.querySelector('input[name="popwatch_offer"]:checked')?.value === 'gift') {
          const destination = new URL(root.dataset.comboUrl,window.location.origin);
          destination.searchParams.set('watch',variantSelect.value);
          destination.searchParams.set('destination',directCheckout ? 'checkout' : 'cart');
          const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
          if (preview) destination.searchParams.set('preview_theme_id',preview);
          window.location.assign(destination.pathname + destination.search);
          return;
        }
        const items = [{id:variantSelect.value,quantity:1}];
        if (s.combined) items.push({id:bracelet.value,quantity:1});
        const status = root.querySelector('[data-status]');
        status.textContent = '';
        purchasePending = true;
        updatePurchase();
        (directCheckout ? buyNow : submit).setAttribute('aria-busy','true');
        try {
          const response = await fetch(root.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
          const data = await response.json();
          if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : status.dataset.error);
          window.location.assign(directCheckout ? root.dataset.checkoutUrl : root.dataset.cartUrl);
        } catch(error) {
          status.textContent = status.dataset.error;
          purchasePending = false;
          submit.removeAttribute('aria-busy'); buyNow?.removeAttribute('aria-busy'); updatePurchase();
        }
      });
      activateColor();
      this.addEventListener('keydown', event => {
        if (!event.target.closest('.rpp-gallery') || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
        const group = activeGallery(); if (!group) return;
        const slides = [...group.querySelectorAll('[data-slide]')];
        showSlide(group,slides.findIndex(slide=>!slide.hidden)+(event.key==='ArrowRight'?1:-1));
        event.preventDefault();
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rp-service"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-tracking-form]').forEach(form=>{
  if (form.dataset.ready) return;
  form.dataset.ready='true';
  form.addEventListener('submit',event=>{
    event.preventDefault();
    if (!form.reportValidity()) return;
    const number=form.elements.tracking.value.trim().replace(/\s+/g,'');
    if (!/^[A-Za-z0-9-]{5,80}$/.test(number)) return;
    const target=new URL('https://t.17track.net/fr');
    target.hash='nums='+encodeURIComponent(number);
    window.open(target.href,'_blank','noopener,noreferrer');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rp-silicone"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rp-silicone-product')) {
  customElements.define('rp-silicone-product', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const root = this;
      const form = root.querySelector('form');
      const variantSelect = root.querySelector('[data-variant]');
      const galleries = [...root.querySelectorAll('[data-gallery-color]')];
      const choices = [...root.querySelectorAll('[data-choice]')];
      const activeGallery = () => galleries.find(group => !group.hidden);
      const showSlide = (group, index) => {
        const slides = [...group.querySelectorAll('[data-slide]')];
        if (!slides.length) return;
        const selected = ((index % slides.length) + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== selected; });
        group.querySelectorAll('[data-thumb]').forEach((button, i) => button.setAttribute('aria-pressed', String(i === selected)));
        group.querySelector('[data-image-count]').textContent = (selected + 1) + ' / ' + slides.length;
      };
      galleries.forEach(group => {
        group.querySelectorAll('[data-thumb]').forEach(button => button.addEventListener('click', () => showSlide(group, Number(button.dataset.thumb) - 1)));
        group.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => {
          const slides = [...group.querySelectorAll('[data-slide]')];
          const index = slides.findIndex(slide => !slide.hidden);
          showSlide(group, index + Number(button.dataset.step));
        }));
      });
      const money = cents => new Intl.NumberFormat(root.dataset.locale || 'fr-FR', { style:'currency', currency:root.dataset.currency || 'EUR' }).format(cents / 100);
      const submit = root.querySelector('[data-submit]');
      const buyNow = root.querySelector('[data-buy-now]');
      let purchasePending = false;
      const combo = root.querySelector('[data-combo]');
      const bracelet = root.querySelector('[data-bracelet]');
      const selectedOption = select => select?.selectedOptions[0];
      const selection = () => {
        const watch = selectedOption(variantSelect);
        const strap = selectedOption(bracelet);
        const combined = Boolean(combo?.checked);
        const validWatch = watch?.dataset.available === 'true' && Number(watch.dataset.price) > 0;
        const validStrap = !combined || (strap?.dataset.available === 'true' && Number(strap.dataset.price) > 0);
        return { watch, strap, combined, enabled:root.dataset.checkoutEnabled === 'true', valid:Boolean(validWatch && validStrap) };
      };
      const updatePurchase = () => {
        if (!submit) return;
        const s = selection();
        const cents = Number(s.watch?.dataset.price || 0) + (s.combined ? Number(s.strap?.dataset.price || 0) : 0);
        root.querySelector('[data-price]').textContent = cents > 0 ? money(cents) : '';
        submit.disabled = purchasePending || !s.enabled || !s.valid;
        if (buyNow) buyNow.disabled = submit.disabled;
        submit.firstChild.textContent = !s.enabled ? submit.dataset.pendingLabel : s.valid ? submit.dataset.addLabel : submit.dataset.unavailableLabel;
        if (bracelet) bracelet.disabled = !s.combined;
      };
      const activateColor = () => {
        const option = selectedOption(variantSelect);
        const color = option?.dataset.color;
        const matching = galleries.find(group => group.dataset.galleryColor === color || group.dataset.legacyColor === color);
        galleries.forEach(group => { group.hidden = group !== matching; });
        choices.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.choice === variantSelect?.value)));
        if (!matching) return;
        showSlide(matching, 0);
        root.querySelector('[data-current-color]').textContent = matching.dataset.galleryColor;
        root.querySelector('[data-spec-color]').textContent = matching.dataset.colorLabel || color;
        const detail = root.querySelector('[data-detail-image]');
        detail.src = matching.dataset.detail;
        detail.alt = color;
        ['one','two','three'].forEach(key => {
          const image = root.querySelector('[data-story-image="' + key + '"]');
          const dataKey = 'story' + key[0].toUpperCase() + key.slice(1);
          if (!image) return;
          image.src = matching.dataset[dataKey];
          image.alt = color + " — " + image.closest("article").querySelector("h2").textContent;
        });
        updatePurchase();
      };
      choices.forEach(button => button.addEventListener('click', () => {
        variantSelect.value = button.dataset.choice;
        activateColor();
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variantSelect.value);
        window.history.replaceState({}, '', url);
      }));
      variantSelect?.addEventListener('change', activateColor);
      root.querySelectorAll('[data-color-scroll]').forEach(button => button.addEventListener('click', () => {
        root.querySelector('[data-color-strip]').scrollBy({left:Number(button.dataset.colorScroll) * 174,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }));
      const tabs = [...root.querySelectorAll('[data-tab]')];
      const selectTab = button => {
        tabs.forEach(tab => { const active = tab === button; tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1; });
        root.querySelectorAll('[data-panel]').forEach(panel => { panel.hidden = panel.dataset.panel !== button.dataset.tab; });
      };
      tabs.forEach((button, index) => {
        button.addEventListener('click', () => selectTab(button));
        button.addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          let target = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          selectTab(tabs[target]); tabs[target].focus();
        });
      });
      combo?.addEventListener('change', updatePurchase);
      bracelet?.addEventListener('change', updatePurchase);
      form?.addEventListener('submit', async event => {
        event.preventDefault();
        const s = selection();
        if (purchasePending || !s.enabled || !s.valid) return;
        const directCheckout = event.submitter === buyNow;
        const items = [{id:variantSelect.value,quantity:1}];
        if (s.combined) items.push({id:bracelet.value,quantity:1});
        const status = root.querySelector('[data-status]');
        status.textContent = '';
        purchasePending = true;
        updatePurchase();
        (directCheckout ? buyNow : submit).setAttribute('aria-busy','true');
        try {
          const response = await fetch(root.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
          const data = await response.json();
          if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : status.dataset.error);
          window.location.assign(directCheckout ? root.dataset.checkoutUrl : root.dataset.cartUrl);
        } catch(error) {
          status.textContent = status.dataset.error;
          purchasePending = false;
          submit.removeAttribute('aria-busy'); buyNow?.removeAttribute('aria-busy'); updatePurchase();
        }
      });
      activateColor();
      this.addEventListener('keydown', event => {
        if (!event.target.closest('.rpp-gallery') || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
        const group = activeGallery(); if (!group) return;
        const slides = [...group.querySelectorAll('[data-slide]')];
        showSlide(group,slides.findIndex(slide=>!slide.hidden)+(event.key==='ArrowRight'?1:-1));
        event.preventDefault();
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rp-strap"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rp-strap-product')) {
  customElements.define('rp-strap-product', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const root = this;
      const form = root.querySelector('form');
      const variantSelect = root.querySelector('[data-variant]');
      const galleries = [...root.querySelectorAll('[data-gallery-color]')];
      const choices = [...root.querySelectorAll('[data-choice]')];
      const activeGallery = () => galleries.find(group => !group.hidden);
      const showSlide = (group, index) => {
        const slides = [...group.querySelectorAll('[data-slide]')];
        if (!slides.length) return;
        const selected = ((index % slides.length) + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== selected; });
        group.querySelectorAll('[data-thumb]').forEach((button, i) => button.setAttribute('aria-pressed', String(i === selected)));
        group.querySelector('[data-image-count]').textContent = (selected + 1) + ' / ' + slides.length;
      };
      galleries.forEach(group => {
        group.querySelectorAll('[data-thumb]').forEach(button => button.addEventListener('click', () => showSlide(group, Number(button.dataset.thumb) - 1)));
        group.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => {
          const slides = [...group.querySelectorAll('[data-slide]')];
          const index = slides.findIndex(slide => !slide.hidden);
          showSlide(group, index + Number(button.dataset.step));
        }));
      });
      const money = cents => new Intl.NumberFormat(root.dataset.locale || 'fr-FR', { style:'currency', currency:root.dataset.currency || 'EUR' }).format(cents / 100);
      const submit = root.querySelector('[data-submit]');
      const buyNow = root.querySelector('[data-buy-now]');
      let purchasePending = false;
      const combo = root.querySelector('[data-combo]');
      const bracelet = root.querySelector('[data-bracelet]');
      const selectedOption = select => select?.selectedOptions[0];
      const selection = () => {
        const watch = selectedOption(variantSelect);
        const strap = selectedOption(bracelet);
        const combined = Boolean(combo?.checked);
        const validWatch = watch?.dataset.available === 'true' && Number(watch.dataset.price) > 0;
        const validStrap = !combined || (strap?.dataset.available === 'true' && Number(strap.dataset.price) > 0);
        return { watch, strap, combined, enabled:root.dataset.checkoutEnabled === 'true', valid:Boolean(validWatch && validStrap) };
      };
      const updatePurchase = () => {
        if (!submit) return;
        const s = selection();
        const cents = Number(s.watch?.dataset.price || 0) + (s.combined ? Number(s.strap?.dataset.price || 0) : 0);
        root.querySelector('[data-price]').textContent = cents > 0 ? money(cents) : '';
        submit.disabled = purchasePending || !s.enabled || !s.valid;
        if (buyNow) buyNow.disabled = submit.disabled;
        submit.firstChild.textContent = !s.enabled ? submit.dataset.pendingLabel : s.valid ? submit.dataset.addLabel : submit.dataset.unavailableLabel;
        if (bracelet) bracelet.disabled = !s.combined;
      };
      const activateColor = () => {
        const option = selectedOption(variantSelect);
        const color = option?.dataset.color;
        const matching = galleries.find(group => group.dataset.galleryColor === color || group.dataset.legacyColor === color);
        galleries.forEach(group => { group.hidden = group !== matching; });
        choices.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.choice === variantSelect?.value)));
        if (!matching) return;
        showSlide(matching, 0);
        root.querySelector('[data-current-color]').textContent = matching.dataset.galleryColor;
        root.querySelector('[data-spec-color]').textContent = matching.dataset.colorLabel || color;
        const detail = root.querySelector('[data-detail-image]');
        detail.src = matching.dataset.detail;
        detail.alt = color;
        ['one','two','three'].forEach(key => {
          const image = root.querySelector('[data-story-image="' + key + '"]');
          const dataKey = 'story' + key[0].toUpperCase() + key.slice(1);
          image.src = matching.dataset[dataKey];
          image.alt = color;
        });
        updatePurchase();
      };
      choices.forEach(button => button.addEventListener('click', () => {
        variantSelect.value = button.dataset.choice;
        activateColor();
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variantSelect.value);
        window.history.replaceState({}, '', url);
      }));
      variantSelect?.addEventListener('change', activateColor);
      root.querySelectorAll('[data-color-scroll]').forEach(button => button.addEventListener('click', () => {
        root.querySelector('[data-color-strip]').scrollBy({left:Number(button.dataset.colorScroll) * 174,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }));
      const tabs = [...root.querySelectorAll('[data-tab]')];
      const selectTab = button => {
        tabs.forEach(tab => { const active = tab === button; tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1; });
        root.querySelectorAll('[data-panel]').forEach(panel => { panel.hidden = panel.dataset.panel !== button.dataset.tab; });
      };
      tabs.forEach((button, index) => {
        button.addEventListener('click', () => selectTab(button));
        button.addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          let target = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          selectTab(tabs[target]); tabs[target].focus();
        });
      });
      combo?.addEventListener('change', updatePurchase);
      bracelet?.addEventListener('change', updatePurchase);
      form?.addEventListener('submit', async event => {
        event.preventDefault();
        const s = selection();
        if (purchasePending || !s.enabled || !s.valid) return;
        const directCheckout = event.submitter === buyNow;
        const items = [{id:variantSelect.value,quantity:1}];
        if (s.combined) items.push({id:bracelet.value,quantity:1});
        const status = root.querySelector('[data-status]');
        status.textContent = '';
        purchasePending = true;
        updatePurchase();
        (directCheckout ? buyNow : submit).setAttribute('aria-busy','true');
        try {
          const response = await fetch(root.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
          const data = await response.json();
          if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : status.dataset.error);
          window.location.assign(directCheckout ? root.dataset.checkoutUrl : root.dataset.cartUrl);
        } catch(error) {
          status.textContent = status.dataset.error;
          purchasePending = false;
          submit.removeAttribute('aria-busy'); buyNow?.removeAttribute('aria-busy'); updatePurchase();
        }
      });
      activateColor();
      this.addEventListener('keydown', event => {
        if (!event.target.closest('.rpp-gallery') || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
        const group = activeGallery(); if (!group) return;
        const slides = [...group.querySelectorAll('[data-slide]')];
        showSlide(group,slides.findIndex(slide=>!slide.hidden)+(event.key==='ArrowRight'?1:-1));
        event.preventDefault();
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
